import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import CookieBanner from './components/CookieBanner';

function App() {
  useEffect(() => {
    document.title = 'Bretech Solutions Group — Complete Marketing Service Solutions';
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <CookieBanner />
    </div>
  );
}

export default App;
